import {
	Box,
	Button,
	Card,
	CardContent,
	Container,
	TextField,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { muiStyles } from "src/Utils/Styles";
import { useApiMutation } from "src/hooks/useApiMutation";

const useStyles = muiStyles;

interface Props {
	handleClose: () => void;
}
const CreateCategory = ({ handleClose }: Props) => {
	const classes = useStyles();

	const { register, handleSubmit, reset } = useForm();

	const { mutate: createCategory, isPending } = useApiMutation<
		{ name: string },
		void
	>({
		method: "POST",
		endPoint: `/api/fair/product-category`,
		invalidateQueries: ["ProductCategories"],
	});

	const handleCreateCategory = (inputs: { name: string }) => {
		createCategory(inputs);
		handleClose();
		reset();
	};

	return (
		<div>
			<Container sx={{ mt: 4 }} maxWidth="lg">
				<Card>
					<CardContent>
						<Box
							component="form"
							onSubmit={handleSubmit(handleCreateCategory)}
							sx={{
								mt: 1,
							}}
						>
							<TextField
								margin="normal"
								required
								fullWidth
								{...register("name")}
								label="Category Name"
								id="name"
								name="name"
								variant="filled"
								type="text"
								className={classes.inputText}
								InputProps={{ classes }}
							/>

							<Button
								type="submit"
								fullWidth
								variant="contained"
								disableElevation
								sx={{
									mt: 3,
									mb: 2,
									py: 1,
								}}
							>
								{isPending ? "Creating..." : "Create Category"}
							</Button>
						</Box>
					</CardContent>
				</Card>
			</Container>
		</div>
	);
};

export default CreateCategory;
